import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Weather } from './Weather';
@Injectable({
  providedIn: 'root'
})
export class WeatherService {
  constructor(private http: HttpClient) {}
  url = 'http://dark-sky.antipasto.biz/okr.json?id' + Math.random();
  proxy = 'https://cors-anywhere.herokuapp.com/';
  getWeather() {
    return this.http.get<Weather>(this.url);
  }
}
